import React from 'react';
type StatChipProps = {
  value: string;
  label: string;
  className?: string;
};
export function StatChip({
  value,
  label,
  className = ''
}: StatChipProps) {
  return <div className={`inline-flex flex-col items-center justify-center px-6 py-3 bg-white/80 backdrop-blur-sm rounded-lg shadow-md ${className}`} data-id="element-359">
      <span className="text-xl md:text-2xl font-bold text-[#0099A1]" data-id="element-360">
        {value}
      </span>
      <span className="text-xs md:text-sm text-[#374047]" data-id="element-361">{label}</span>
    </div>;
}